export const VIDEO_DEVICE = 'video'
export const AUDIO_DEVICE = 'audio'
export const DESKTOP_DEVICE = 'desktop'

export const VIDEO_INPUT_KIND = 'videoinput'
export const AUDIO_INPUT_KIND = 'audioinput'
export const AUDIO_OUTPUT_KIND = 'audiooutput'

export const DEFAULT_AUDIO_DEVICE_ID = 'default'
export const DEFAULT_VIDEO_DEVICE_ID = ''

export const AUDIO_INPUT_DEVICE_KEY = 'audioInputDeviceId'
export const AUDIO_OUTPUT_DEVICE_KEY = 'audioOutputDeviceId'
export const VIDEO_INPUT_DEVICE_KEY = 'videoInputDeviceId'
export const VIDEO_MUTED = 'videoMuted'
export const AUDIO_MUTED = 'audioMuted'

export const CAMERA_FACING_MODE = {
  ENVIRONMENT: 'environment',
  USER: 'user',
}

export enum TabeebConnectEvents {
  TAKING_SNAPSHOT = 'conference.takingSnapshot',
  SNAPSHOT_CREATED = 'conference.snapshotCreated',
  SET_REMOTE_USER_VIDEO_STATE = 'conference.setRemoteUserVideoState',
  SET_REMOTE_USER_AUDIO_STATE = 'SET_REMOTE_USER_AUDIO_STATE',
  ON_RECORDER_VIDEO_ATTACHED = 'conference.onRecorderVideoAttached',
  ON_REMOTE_AUDIO_INDICATOR_UPDATED = 'conference.onRemoteAudioIndicatorUpdated',
  TRACK_MUTE_UPDATED = 'conference.trackMuteUpdated',
  TRACKS_INITIALIZATION_FAILED = 'conference.tracksInitializationFailed',
}
